{
  "menu.newRoute": "New route",
  "menu.routePlanManager": "Saved routes",
  "menu.savedPlaces": "Saved places",
  "menu.vesselConfigurator": "Vessel settings",
  "menu.instructions": "Instructions",
  "menu.tour": "Tutorial tour",
  "menu.information": "Information",
  "information.tabMapLicenses": "Data sources",
  "information.tabOpenSource": "Open source",
  "information.dataSources.osmTitle": "OpenStreetMap",
  "information.dataSources.osmText": "© <0>OpenStreetMap contributors</0>, licensed under <1>ODbL 1.0</1>.",
  "information.dataSources.digitrafficTitle": "Digitraffic (Fintraffic)",
  "information.dataSources.digitrafficText": "Source: <0>Fintraffic / digitraffic.fi</0>, license <1>CC BY 4.0</1>.",
  "information.dataSources.fmiTitle": "Finnish Meteorological Institute",
  "information.dataSources.fmiText": "Source: <0>FMI open data</0>, license <1>CC BY 4.0</1>.",
  "information.dataSources.traficomTitle": "Traficom",
  "information.dataSources.traficomText": "Source: <0>Traficom open data</0>, license <1>CC BY 4.0</1>.",
  "information.dataSources.vaylaTitle": "Finnish Transport Infrastructure Agency",
  "information.dataSources.vaylaText": "Finnish Transport Infrastructure Agency / download service, license CC BY 4.0.",
  "information.dataSources.traficomNauticalTitle": "Finnish Transport and Communications Agency",
  "information.dataSources.traficomNauticalText": "Not for navigation. Does not meet the requirements of a proper nautical chart (open data nautical chart).",
  "information.dataSources.traficomLicenseNotice": "©Traficom lisenssi nro TRAFICOM/108936/00.04.01.10/2026",
  "information.dataSources.traficomWarningText": "VAROITUS: Traficom ei ole tarkistanut tämän tuotteen tietoja, eikä\nse ota siten vastuuta tietojen oikeellisuudesta tai valmistuksen jäl-\nkeisistä muutoksista. Ei ole olemassa takuita siitä, että tämä tuote\nnoudattaa asianmukaisten navigointituotteiden käyttöä koskevia\nkansallisia tai kansainvälisiä säännöksiä.",
  "information.dataSources.mmlTopographicTitle": "National Land Survey of Finland",
  "information.dataSources.mmlTopographicText": "National Land Survey of Finland Topographic Database.",
  "information.dataSources.mmlNamesTitle": "National Land Survey of Finland",
  "information.dataSources.mmlNamesText": "National Land Survey of Finland place names 01/2023.",
  "information.dataSources.smhiTitle": "SMHI",
  "information.dataSources.smhiText": "Source: SMHI.",
  "information.mapLicensesPlaceholder": "Map license information will be added later.",
  "information.openSourceGeneratedFromLockfile": "Open source licenses are generated from package-lock.json.",
  "information.searchPlaceholder": "Search packages…",
  "information.licenseUnknown": "License unknown",
  "information.packageCount": "Packages: {{count}}",
  "menu.userAccount": "User account",
  "menu.harborManagement": "Harbor information management",
  "menu.showHarborUpdateDates": "Show harbor update dates",
  "menu.logout": "Log out",
  "menu.login": "Log in",
  "menu.animate": "Animate",
  "demo.play": "Play",
  "demo.pause": "Pause",
  "demo.speed": "Animation speed",
  "demo.close": "Close animation",
  "demo.beta": "Beta",
  "demo.boat.label": "Boat",
  "demo.boat.scrollHint": "Swipe for more",
  "demo.boat.sailboat": "Day sailer",
  "demo.boat.racingSailboat": "Racing",
  "demo.boat.cruisingSailboat": "Cruiser",
  "demo.boat.smallMotorboat": "Open boat",
  "demo.boat.largeMotorboat": "Cabin boat",
  "demo.boat.speedboat": "Speedboat",
  "demo.boat.rowingBoat": "Rowboat",
  "demo.boat.kayak": "Kayak",
  "demo.boat.submarine": "Submarine",
  "demo.boat.premiumDialog.title": "Sailmate Premium",
  "demo.boat.premiumDialog.message": "“{{boat}}” requires Sailmate Premium. Subscribe to unlock all vessel models for Animate and video export.",
  "demo.boat.premiumDialog.hint": "Premium also includes marine charts, weather, AIS, and advanced navigation tools.",
  "demo.boat.premiumDialog.subscribe": "Subscribe",
  "demo.export.button": "Export video",
  "demo.export.title": "Export route video",
  "demo.export.description": "Renders the full route in {{seconds}} s with the Sailmate logo. Ready for social media.",
  "demo.export.duration": "Video length",
  "demo.export.durationOption": "{{seconds}}s",
  "demo.export.durationRecommended": "Best",
  "demo.export.durationHint": "For this {{distance}} route, {{seconds}}s looks smoothest",
  "demo.export.durationCalmHint": "Prefer a calmer pace? Try {{seconds}}s",
  "demo.export.durationTooShort": "Too short for this route — motion would look rushed",
  "demo.export.durationRushedWarning": "This length may look rushed; a longer video is smoother",
  "demo.export.aspect": "Aspect ratio",
  "demo.export.aspectHintLandscape": "16:9 — YouTube, X, landscape posts",
  "demo.export.aspectHintVertical": "9:16 — Reels, TikTok, Stories",
  "demo.export.scene": "Scene",
  "demo.export.scene.cinematic": "Cinematic",
  "demo.export.scene.follow": "Follow",
  "demo.export.scene.cinematicHint": "The camera pulls out and orbits smoothly. The boat stays in frame and shrinks as we zoom out",
  "demo.export.scene.followHint": "Chase camera behind the boat along the route",
  "demo.export.titleText": "Title",
  "demo.export.titleSource.none": "None",
  "demo.export.titleSource.route": "Route name",
  "demo.export.titleSource.custom": "Custom",
  "demo.export.titleSource.noneHint": "No title on the video",
  "demo.export.titleSource.routeHint": "“{{name}}” fades out after a few seconds",
  "demo.export.titleSource.routeMissing": "Name this route in the route plan to show it",
  "demo.export.titleCustomPlaceholder": "Title on the video",
  "demo.export.titleMaxLength": "{{count}} / {{max}}",
  "demo.export.titleFont": "Font",
  "demo.export.titleFont.finlandica": "Finlandica",
  "demo.export.titleFont.outfit": "Outfit",
  "demo.export.titleFont.libreBaskerville": "Baskerville",
  "demo.export.titleBackground": "Background",
  "demo.export.titleBackground.glow": "Glow",
  "demo.export.titleBackground.dim": "Dim",
  "demo.export.titleBackground.highlight": "Bars",
  "demo.export.titleBackground.light": "Light",
  "demo.export.showElapsedDistance": "Show elapsed distance",
  "demo.export.showElapsedDistanceHint": "Displayed at the bottom of the video",
  "demo.export.distanceUnit": "Distance unit",
  "demo.export.distanceUnitNm": "nm",
  "demo.export.distanceUnitKm": "km",
  "demo.export.cancel": "Cancel",
  "demo.export.create": "Create video",
  "demo.export.rendering": "Creating video… {{percent}}%",
  "demo.export.renderingHint": "Keep this tab open until the download starts.",
  "demo.export.tipLabel": "While you wait",
  "demo.export.tips.0": "A rising tide lifts all boats — except the one still on the trailer.",
  "demo.export.tips.1": "Red, right, returning — unless you’re leaving harbour. Trust the chart, not the rhyme.",
  "demo.export.tips.2": "The wind always fills in five minutes after you’ve furled the jib.",
  "demo.export.tips.3": "GPS is precise. The rock you just found is more precise.",
  "demo.export.tips.4": "If the coffee stays in the mug, you’re not sailing hard enough.",
  "demo.export.tips.5": "Mooring lines are never too long — until they’re round the prop.",
  "demo.export.tips.6": "The forecast is a suggestion. A squall is peer review.",
  "demo.export.tips.7": "There’s no such thing as too many fenders — only too few witnesses.",
  "demo.export.tips.8": "The shortest route is a straight line. The safest one follows the channel.",
  "demo.export.tips.9": "If everything is going to plan, check the tide again.",
  "demo.export.tips.10": "One hand for the ship, one for yourself — and somehow three for the phone.",
  "demo.export.tips.11": "The anchor always bites best just after you’ve told the whole pontoon it’s set.",
  "demo.export.tips.12": "Fair winds and following seas… until lunch, when both reverse out of spite.",
  "demo.export.tips.13": "A dry bilge is a temporary condition, not a character trait.",
  "demo.export.tips.14": "Never shout “I’ve got it!” on the pontoon unless you enjoy theatre.",
  "demo.export.tips.15": "Reef early, reef often — then explain later why you didn’t.",
  "demo.export.tips.16": "The chartplotter is confident. The depth sounder is honest.",
  "demo.export.tips.17": "There’s always time to put a lifejacket on — until suddenly there isn’t.",
  "demo.export.tips.18": "Any fool can carry sail; it takes a sailor to take it down.",
  "demo.export.tips.19": "The best berth is the one you can leave without an audience.",
  "demo.export.tips.20": "Spring lines exist so pride doesn’t meet the next boat.",
  "demo.export.tips.21": "If you can see the bottom, you’re either lucky — or about to explain something.",
  "demo.export.tips.22": "Weather apps refresh. Clouds do not wait for the refresh.",
  "demo.export.tips.23": "Leave a tidy boat for the next watch — even if the next watch is you.",
  "demo.export.success": "Video downloaded",
  "demo.export.error": "Could not create the video",
  "demo.export.unsupported": "Video export is not supported in this browser",
  "menu.chartSettings": "Chart settings",
  "menu.chartSettingsSubtitle": "Units, S57 symbols & palette",
  "toolbar.routingMode": "Route editing mode",
  "toolbar.routingModeOff": "Route editing off",
  "toolbar.routingModeAuto": "Fairway routing",
  "toolbar.routingModeManual": "Line routing",
  "toolbar.reachArea": "Reachable area",
  "toolbar.showReachArea": "Show reachable area",
  "toolbar.hideReachArea": "Hide reachable area",
  "toolbar.setReachArea": "Set reachable area",
  "toolbar.addSailingPoint": "Add sailing point",
  "toolbar.search": "Search",
  "mapControls.zoomIn": "Zoom in",
  "mapControls.zoomOut": "Zoom out",
  "mapControls.resetNorth": "Reset north",
  "mapControls.forecast": "Weather forecast",
  "placeSearch.placeholder": "Search places…",
  "placeSearch.placesPlaceholder": "Search places…",
  "placeSearch.harborsPlaceholder": "Search harbors…",
  "placeSearch.inputLabel": "Search places",
  "placeSearch.tabPlaces": "Places",
  "placeSearch.tabHarbors": "Harbors",
  "placeSearch.emptyHint": "Start typing to search places.",
  "placeSearch.loading": "Loading places…",
  "placeSearch.harborsLoading": "Loading harbors…",
  "placeSearch.unavailable": "Place search unavailable",
  "placeSearch.harborsUnavailable": "Harbor search unavailable",
  "placeSearch.retry": "Retry",
  "placeSearch.harborsEmptyHint": "Start typing to search harbors.",
  "placeSearch.noResults": "No results",
  "placeSearch.clear": "Clear",
  "placeSearch.close": "Close",
  "toolbar.layers": "Map layers",
  "toolbar.menu": "Menu",
  "chartSettings.title": "Chart settings",
  "chartSettings.symbolSize": "Symbol size",
  "chartSettings.symbolSizeSmall": "Small",
  "chartSettings.symbolSizeMedium": "Medium",
  "chartSettings.symbolSizeLarge": "Large",
  "chartSettings.symbolStyle": "Symbol style",
  "chartSettings.symbolStyleOfficial": "Official",
  "chartSettings.symbolStyleColourful": "Colourful",
  "chartSettings.palette": "Palette",
  "chartSettings.paletteNormal": "Normal",
  "chartSettings.paletteNight": "Night",
  "chartSettings.paletteHighContrast": "High contrast",
  "chartSettings.units": "Units",
  "chartSettings.unitsNautical": "kn, nm",
  "chartSettings.unitsSi": "km/h, km",
  "chartSettings.s57Section": "S57 chart",
  "chartSettings.s57SectionDescription": "These settings affect only S57 charts.",
  "chartSettings.simplifiedS57": "Simplified chart",
  "chartSettings.simplifiedS57Description": "Hide soundings, light sectors, depth contours, restricted areas, cables, and pipelines for faster rendering.",
  "inactivity.title": "Refresh paused",
  "inactivity.body": "Auto-refreshing AIS and weather has paused due to inactivity. Continue to resume live updates.",
  "inactivity.continue": "Continue refreshing",
  "layers.title": "Layers",
  "layers.sectionCharts": "Charts",
  "layers.sectionOverlays": "Overlays",
  "layers.sectionSummaryNone": "None on",
  "layers.sectionSummaryMore": "+{{count}}",
  "layers.sectionPois": "Places & POIs",
  "layers.sectionRoutes": "Routes",
  "layers.sectionRestrictions": "Restriction areas",
  "layers.sectionLiveData": "Live data",
  "layers.weather": "Weather observations",
  "layers.harbor": "Harbors",
  "layers.recreationSites": "Recreation sites",
  "layers.septic": "Septic emptying stations",
  "layers.ais": "AIS targets",
  "layers.ice": "Ice conditions",
  "layers.navWarnings": "Navigational warnings",
  "navWarning.number": "Warning {{number}}",
  "navWarning.published": "Published {{time}}",
  "navWarning.dataAttribution": "Data: Traficom navigational warnings (open data)",
  "information.dataSources.traficomNavWarningsText": "Includes navigational warnings (Merivaroitukset) via Traficom open WFS.",
  "forecast.attr.wind": "Wind",
  "forecast.attr.wind_gust": "Wind gust",
  "forecast.attr.temperature": "Temperature",
  "forecast.attr.rainfall": "Rainfall",
  "forecast.attr.cloud_cover": "Cloud cover",
  "forecast.isobars": "Pressure",
  "forecast.play": "Play",
  "forecast.pause": "Pause",
  "forecast.prev": "Previous hour",
  "forecast.next": "Next hour",
  "forecast.loading": "Loading forecast…",
  "forecast.modelRun": "Model run {{time}}",
  "forecast.source": "Ilmatieteenlaitos Harmonie",
  "forecast.point.title": "Forecast here",
  "forecast.point.close": "Close",
  "forecast.point.noData": "No data",
  "forecast.premiumTimeline": "Later hours require Premium",
  "layers.networkTiles": "Mobile network quality",
  "layers.networkTilesTech": "Network",
  "layers.networkTilesTech4g": "4G",
  "layers.networkTilesTech5g": "5G",
  "layers.networkTilesOperator": "Operator",
  "layers.networkTilesOperatorElisa": "Elisa",
  "layers.networkTilesOperatorDna": "DNA",
  "layers.networkTilesOperatorTelia": "Telia",
  "layers.networkTilesMetric": "Metric",
  "layers.networkTilesMetricDownload": "Download speed",
  "layers.networkTilesMetricUpload": "Upload speed",
  "layers.networkTilesMetricLatency": "Latency",
  "layers.networkTilesMetricRsrp": "RSRP signal",
  "layers.networkTilesLegendTitle": "Network quality legend",
  "layers.networkTilesLegendLoading": "Loading network tiles",
  "layers.networkTilesBandVeryBad": "Very bad",
  "layers.networkTilesBandBad": "Bad",
  "layers.networkTilesBandFair": "Fair",
  "layers.networkTilesBandGood": "Good",
  "layers.networkTilesBandExcellent": "Excellent",
  "layers.raster2025": "Nautical chart (raster)",
  "layers.rasterSpecial": "Special charts",
  "layers.avoinMerikartta": "Open nautical chart (vector)",
  "layers.maastokartta": "Terrain map (Maastokartta)",
  "layers.combined": "Nautical & terrain map (vector)",
  "layers.s57": "Nautical chart (S57, vector)",
  "layers.scoutRoutes": "Scout routes",
  "layers.scoutRouting": "Auto routing via scout routes",
  "layers.savedPlaces": "Saved places",
  "layers.restriction01SpeedLimit": "Speed limit",
  "layers.restriction02NoWake": "No wake",
  "layers.restriction03NoWindsurfing": "Windsurfing prohibited",
  "layers.restriction04NoJetSki": "Jet skiing prohibited",
  "layers.restriction05NoMotorPower": "Vessel passage under engine power prohibited",
  "layers.restriction06NoAnchoring": "Anchoring prohibited",
  "layers.comingSoon": "Coming soon",
  "layers.scoutSubscription": "Scout subscription",
  "layers.premium": "Premium",
  "layers.beta": "Beta",
  "layers.premiumBeta": "Premium beta",
  "s57.infoDialogTitle": "S57 Vector Charts",
  "s57.infoDialogParagraph1": "Thanks for trying Sailmate's new vector chart. We're building the best chart we can for home waters — your feedback helps us get there.",
  "s57.infoDialogParagraph2": "The chart uses Traficom’s official S-57 data. We’ve tuned the presentation for Finnish boaters; tell us how it looks and how content reads at different zoom levels.",
  "s57.infoDialogMobileSpring": "Coming to mobile apps in spring.",
  "s57.betaWarning": "S57 maps are in beta testing",
  "s57.feedbackTitle": "Vector chart feedback",
  "s57.feedbackSendButton": "Send feedback",
  "s57.feedbackButton": "Feedback",
  "s57.feedbackMailtoHint": "You can send feedback in Gmail in your browser or in your installed mail app. If nothing opens, copy the address and paste it into your email.",
  "s57.feedbackOpenInGmail": "Open in Gmail",
  "s57.feedbackOpenInMailApp": "Mail app",
  "s57.feedbackCopyEmail": "Copy address",
  "s57.feedbackCopyEmailSuccess": "Address copied — paste it into your email.",
  "s57.feedbackCopyEmailFailed": "Could not copy — select the address above manually.",
  "reachableArea.title": "Reachable area",
  "reachableArea.distanceNm": "Distance budget",
  "reachableArea.nm": "nm",
  "reachableArea.km": "km",
  "reachableArea.hint": "Shows fairways reachable from the last waypoint using local fairway routing.",
  "routePlan.downloadGPX": "Download plan as GPX",
  "routePlan.groupLegs": "Group selected legs",
  "routePlan.ungroupLegs": "Ungroup legs",
  "routePlan.ungroupLegsAria": "Ungroup",
  "routePlan.title": "Route plan",
  "routePlan.nameLabel": "Route name",
  "routePlan.namePlaceholder": "Unnamed route",
  "routePlan.totalDistance": "Total distance",
  "routePlan.eta": "ETA",
  "routePlan.waypoints": "Waypoints",
  "routePlan.waypoint": "Waypoint",
  "routePlan.start": "Start",
  "routePlan.finish": "Finish",
  "routePlan.emptyTitle": "No waypoints yet",
  "routePlan.emptyHintOff": "Choose routing mode from the toolbar to start planning.",
  "routePlan.emptyHintOn": "Long-press the map to add waypoints. Tap a row to delete, or delete on the map.",
  "routePlan.clear": "Clear",
  "routePlan.clearConfirmTitle": "Clear route?",
  "routePlan.clearConfirmBody": "You have changes that haven't been saved to the cloud. Clearing will discard them.",
  "routePlan.calculating": "Calculating route…",
  "routePlan.savedLocally": "Saved locally",
  "routePlan.untitledRoute": "Untitled route",
  "routePlan.editVesselSettings": "Edit",
  "routePlan.cloudTitle": "Cloud sync",
  "routePlan.cloudSubtitle": "Save this route to access it across devices.",
  "routePlan.cloudNameLabel": "Route name",
  "routePlan.cloudNameHelper": "The name is saved to the cloud when you click Save.",
  "routePlan.cloudSave": "Save to cloud",
  "routePlan.cloudSaveChanges": "Save changes",
  "routePlan.cloudRenameHint": "Rename requires Save",
  "routePlan.cloudNotSaved": "Not saved",
  "routePlan.cloudSynced": "Synced",
  "routePlan.cloudSyncing": "Syncing…",
  "routePlan.cloudSyncError": "Sync failed",
  "routePlan.cloudPending": "Changes pending",
  "routePlan.cloudAutoSync": "Automatic save enabled",
  "routePlan.cloudAutoSaveLabel": "Automatic save",
  "routePlan.cloudSaveManually": "Save manually when ready.",
  "routePlan.cloudLastSynced": "Last synced at {{time}}",
  "routePlan.cloudLoginTitle": "Sign in to save routes",
  "routePlan.cloudLoginBody": "Create an account to store routes in the cloud and keep them synced.",
  "routePlan.cloudLoginCta": "Sign in",
  "routePlan.cloudPremiumTitle": "Premium required",
  "routePlan.cloudPremiumBody": "Cloud saving is a Premium feature.",
  "routePlan.cloudPremiumCta": "Upgrade",
  "routePlan.cloudCheckingAccount": "Checking account…",
  "routePlan.cloudSaveError": "Failed to save route.",
  "routePlan.cloudAuthError": "Missing session token.",
  "routePlan.cloudProfileMissing": "Profile not available.",
  "routePlan.cloudNoWaypoints": "Add at least one waypoint to save.",
  "routePlan.cloudLoginRequired": "Sign in to save this route.",
  "routePlan.cloudPremiumRequired": "Premium subscription required.",
  "routePlan.routingAutoFailed": "Failed to find a route.",
  "routePlan.addWaypointFailed": "Failed to add waypoint.",
  "routePlan.insertWaypointFailed": "Failed to insert waypoint.",
  "routePlan.removeWaypointFailed": "Failed to remove waypoint.",
  "routePlan.relocateWaypointFailed": "Failed to move waypoint.",
  "routePlan.loadRouteFailed": "Failed to load route.",
  "routePlan.editingEnabled": "Route editing enabled",
  "routePlan.waypointLimitTitle": "Sign in to plan longer routes",
  "routePlan.waypointLimitMessage": "You can add up to three waypoints without an account. Sign in to unlock longer route planning and sync your routes.",
  "routePlan.waypointLimitHint": "It only takes a minute — we’ll send a one-time code to your email.",
  "routePlan.waypointLimitCta": "Sign in",
  "routePlan.summary": "Route summary",
  "routePlan.etaLabelShort": "ETA {{eta}}",
  "routePlan.trackedWaypointChip": "Track",
  "routePlan.waypointModeAuto": "Fairway",
  "routePlan.waypointModeManual": "Line",
  "routePlan.deleteWaypointTitle": "Delete waypoint?",
  "routePlan.deleteWaypointMessage": "Are you sure you want to delete \"{{waypoint}}\" (waypoint {{index}})? This action cannot be undone.",
  "routePlan.delete": "Delete",
  "routePlan.cancel": "Cancel",
  "routes.title": "My routes",
  "routes.subtitle": "Manage and load your saved routes.",
  "routes.currentRoute": "Current route",
  "routes.selectedRoute": "Selected route",
  "routes.saveNew": "Save as new",
  "routes.saveNewDialogTitle": "Name for new route",
  "routes.overwrite": "Overwrite selected",
  "routes.loadToPlanner": "Open",
  "routes.delete": "Delete",
  "routes.cancel": "Cancel",
  "routes.refresh": "Refresh",
  "routes.loading": "Loading routes…",
  "routes.ready": "Ready",
  "routes.calculating": "Calculating",
  "routes.count": "{{count}} routes",
  "routes.waypointsCount": "{{count}} waypoints",
  "routes.updatedAt": "Updated {{date}}",
  "routes.searchPlaceholder": "Search routes",
  "routes.emptyTitle": "No saved routes yet",
  "routes.emptyHint": "Save your current route to see it here.",
  "routes.selectTitle": "Select a route",
  "routes.selectHint": "Pick a route to view details and actions.",
  "routes.loginRequired": "Sign in to view your saved routes.",
  "routes.login": "Sign in",
  "routes.sharedHint": "Shared route code",
  "routes.deleteConfirmTitle": "Delete route?",
  "routes.deleteConfirmMessage": "Delete \"{{name}}\"? This cannot be undone.",
  "routes.errorMissingToken": "Missing access token.",
  "routes.errorMissingProfile": "Missing user profile id.",
  "routes.errorMissingSelection": "Select a route first.",
  "routes.errorSubscriptionRequired": "A valid subscription is required to save and manage routes.",
  "routes.errorGeneric": "Something went wrong.",
  "routes.untitledRoutePlaceholder": "Untitled route",
  "routes.importExport.exportCurrent": "Export current GPX",
  "routes.importExport.exportSelected": "Export as GPX",
  "routes.importExport.exportAll": "Export all GPX",
  "routes.importExport.importRoute": "Import route GPX",
  "routes.importExport.exportedSingle": "Route exported as GPX.",
  "routes.importExport.exportedAll": "{{count}} routes exported as GPX.",
  "routes.importExport.importedRoute": "Route imported to planner.",
  "routes.importExport.invalidRouteGpx": "No valid route points found in GPX.",
  "routes.importExport.invalidXml": "Invalid GPX file.",
  "routes.importExport.importFailed": "Failed to import route GPX.",
  "routes.importExport.noSavedRoutes": "No saved routes to export.",
  "routes.importExport.noCurrentRoute": "Current route has no points to export.",
  "places.title": "My places",
  "places.subtitle": "Manage your saved places.",
  "places.selectedPlace": "Selected place",
  "places.nameLabel": "Name",
  "places.latitude": "Latitude",
  "places.longitude": "Longitude",
  "places.update": "Save changes",
  "places.delete": "Delete",
  "places.cancel": "Cancel",
  "places.refresh": "Refresh",
  "places.loading": "Loading places…",
  "places.count": "{{count}} places",
  "places.updatedAt": "Updated {{date}}",
  "places.searchPlaceholder": "Search places",
  "places.emptyTitle": "No saved places yet",
  "places.emptyHint": "Your saved places will show up here.",
  "places.selectTitle": "Select a place",
  "places.selectHint": "Pick a place to view details and actions.",
  "places.loginRequired": "Sign in to view your saved places.",
  "places.login": "Sign in",
  "places.deleteConfirmTitle": "Delete place?",
  "places.deleteConfirmMessage": "Delete \"{{name}}\"? This cannot be undone.",
  "places.errorMissingToken": "Missing access token.",
  "places.errorMissingProfile": "Missing user profile id.",
  "places.errorMissingSelection": "Select a place first.",
  "places.errorInvalidName": "Enter a name.",
  "places.errorInvalidCoordinates": "Enter valid coordinates.",
  "places.errorSubscriptionRequired": "A valid subscription is required to manage saved places.",
  "places.errorGeneric": "Something went wrong.",
  "places.untitledPlacePlaceholder": "Untitled place",
  "places.importExport.exportSelected": "Export as GPX",
  "places.importExport.exportAll": "Export all GPX",
  "places.importExport.importPlace": "Import place GPX",
  "places.importExport.exportedSingle": "Place exported as GPX.",
  "places.importExport.exportedAll": "{{count}} places exported as GPX.",
  "places.importExport.importedPlace": "Place imported.",
  "places.importExport.invalidPlaceGpx": "No valid waypoint found in GPX.",
  "places.importExport.invalidXml": "Invalid GPX file.",
  "places.importExport.importFailed": "Failed to import place GPX.",
  "places.importExport.noSavedPlaces": "No saved places to export.",
  "places.createNewPlace": "Create New Place",
  "places.namePlaceholder": "Enter place name",
  "places.save": "Save",
  "places.centerOnMap": "Center map here",
  "places.coordinates": "Coordinates",
  "places.unnamedPlace": "Unnamed place",
  "places.subscriptionRequiredTitle": "Subscription Required",
  "places.subscriptionRequiredMessage": "Saving places requires an active subscription. Subscribe to unlock this feature and manage your favorite locations.",
  "places.subscriptionRequiredHint": "With a subscription, you can save unlimited places, access advanced routing features, and more.",
  "places.viewSubscription": "View Subscription",
  "places.loginRequiredTitle": "Sign in to save places",
  "places.loginRequiredMessage": "Create an account to save places and keep them synced across devices.",
  "places.loginRequiredHint": "Creating an account is quick and easy. You only need an email address where we can send a verification code.",
  "places.loginRequiredCta": "Sign in",
  "places.categoryLabel": "Category",
  "places.descriptionLabel": "Description",
  "places.descriptionPlaceholder": "Optional description",
  "places.filterCategories": "Categories",
  "places.filterAllCategories": "All categories",
  "places.sortDistance": "Distance",
  "places.saveAndShowTitle": "Save & show icons?",
  "places.saveAndShowMessage": "Your My places layer is hidden. Save this place and show icons on the map?",
  "places.saveAndShow": "Save & show icons",
  "places.saveWithoutShowing": "Save without showing",
  "places.categories.FAVORITE": "Favorite",
  "places.categories.FISH": "Fishing spot",
  "places.categories.COTTAGE": "Cottage",
  "places.categories.WARNING": "Warning",
  "places.categories.INFO": "Info",
  "places.categories.SIGHT": "Sight",
  "places.categories.ANCHOR": "Anchorage",
  "places.photos.title": "Photos",
  "places.photos.add": "Add",
  "places.photos.remove": "Remove photo",
  "places.photos.onlineOnly": "Photos can only be managed while online.",
  "places.photos.maxReached": "You can add up to {{count}} photos.",
  "places.photos.invalidType": "Choose an image file.",
  "places.photos.uploadFailed": "Failed to upload photo.",
  "places.photos.deleteFailed": "Failed to remove photo.",
  "places.photos.viewFullscreen": "View photo fullscreen",
  "places.photos.previous": "Previous photo",
  "places.photos.next": "Next photo",
  "common.cancel": "Cancel",
  "common.done": "Done",
  "common.edit": "Edit",
  "common.sortBy": "Sort by",
  "common.sortOrder": "Order",
  "common.sortAttributeUpdated": "Updated",
  "common.sortAttributeCreated": "Created",
  "common.sortAttributeName": "Name",
  "common.sortAsc": "Asc",
  "common.sortDesc": "Desc",
  "drawer.openRoutePlan": "Open route plan",
  "drawer.closeRoutePlan": "Close route plan",
  "drawer.showRoutePlan": "Show route plan",
  "drawer.hideRoutePlan": "Hide route plan",
  "common.loginRequired": "Login required",
  "common.checkingAccount": "Checking account…",
  "common.subscriptionRequired": "Subscription needed",
  "common.close": "Close",
  "common.notNow": "Not now",
  "common.language": "Language",
  "recreation.titleFallback": "Recreation site",
  "recreation.loading": "Loading…",
  "recreation.loadError": "Could not load site details.",
  "recreation.description": "Description",
  "recreation.showMore": "Show more",
  "recreation.showLess": "Show less",
  "recreation.highlights": "Highlights",
  "recreation.arrival": "How to get there",
  "recreation.accessibility": "Accessibility",
  "recreation.rules": "Rules",
  "recreation.contacts": "Contact",
  "recreation.details": "Details",
  "recreation.category": "Category",
  "recreation.geometry": "Geometry",
  "recreation.owner": "Owner",
  "recreation.admin": "Administrator",
  "recreation.lastModified": "Last modified",
  "recreation.openInLipas": "Open in Lipas",
  "recreation.dataAsOf": "Data as of {{date}}",
  "recreation.imageCopyright": "© {{copyright}}",
  "recreation.imageAltFallback": "Recreation site photo",
  "recreation.previousImage": "Previous image",
  "recreation.nextImage": "Next image",
  "recreation.imageIndex": "{{current}} / {{total}}",
  "harbor.titleFallback": "Harbor",
  "harbor.portNumber": "Port",
  "harbor.depth": "Depth",
  "harbor.places": "Places",
  "harbor.mooring": "Mooring",
  "harbor.official": "Official",
  "harbor.unofficial": "Unofficial",
  "harbor.amenitiesTitle": "Amenities",
  "harbor.openChart": "Open harbor chart",
  "harbor.scoutPort": "Scout port",
  "harbor.spv": "SPV",
  "harbor.overview": "Overview",
  "harbor.portInfo": "Port info",
  "harbor.servicesTitle": "Services",
  "harbor.relatedContent": "Related content",
  "harbor.relatedArticles": "Related articles",
  "harbor.linksTitle": "Links",
  "harbor.scoutTip": "Includes scout information!",
  "harbor.openContent": "Open content",
  "harbor.openArticle": "Open article",
  "harbor.openScoutChart": "Open scout chart",
  "harbor.openAerial": "Open aerial image",
  "harbor.openSeptit": "Open septit.net",
  "harbor.amenities.toilet": "Toilet",
  "harbor.amenities.drinkingWater": "Drinking water",
  "harbor.amenities.sauna": "Sauna",
  "harbor.amenities.fuel": "Fuel",
  "harbor.amenities.restaurant": "Restaurant",
  "harbor.amenities.kiosk": "Kiosk",
  "harbor.amenities.recycling": "Recycling",
  "harbor.services.wc": "WC",
  "harbor.services.shower": "Shower",
  "harbor.services.drinking_water": "Drinking water",
  "harbor.services.electricity": "Electricity",
  "harbor.services.harbour": "Harbor",
  "harbor.services.fuel": "Fuel",
  "harbor.services.boat_ramp": "Boat ramp",
  "harbor.services.septic_tank": "Septic tank",
  "harbor.services.wash_house": "Laundry",
  "harbor.services.engine": "Engine service",
  "harbor.services.restaurant": "Restaurant",
  "harbor.services.cafe": "Cafe",
  "harbor.services.kiosk": "Kiosk",
  "harbor.services.foodkiosk": "Food kiosk",
  "harbor.services.sauna": "Sauna",
  "harbor.services.beach": "Beach",
  "harbor.services.playground": "Playground",
  "harbor.services.grill": "Grill",
  "harbor.services.naturetrail": "Nature trail",
  "harbor.services.sigthseeing": "Sightseeing",
  "harbor.services.amusement": "Amusement",
  "harbor.services.shop": "Shop",
  "harbor.services.pharmacy": "Pharmacy",
  "harbor.services.bank": "Bank",
  "harbor.services.post_office": "Post office",
  "harbor.services.alko": "Alko",
  "harbor.services.bus": "Bus",
  "harbor.services.ferry": "Ferry",
  "harbor.services.accommodation": "Accommodation",
  "harbor.services.guidance": "Guidance",
  "harbor.services.recycling": "Recycling",
  "harbor.services.otherservice": "Other services",
  "harbor.services.dentist": "Dentist",
  "harbor.services.taxi": "Taxi",
  "harbor.services.doctor": "Doctor",
  "harbor.services.vet": "Vet",
  "harbor.services.wlan": "Wi‑Fi",
  "harbor.voting.sectionTitle": "Guest Harbor of the Year vote",
  "harbor.voting.rateHarborCard": "Rate harbor",
  "harbor.voting.rateHarbor": "Rate harbor",
  "harbor.voting.rateThisHarbor": "Rate this harbor:",
  "harbor.voting.leaveComment": "Leave a comment",
  "harbor.voting.send": "Send",
  "harbor.voting.sending": "Sending…",
  "harbor.voting.ratingSaved": "Rating saved!",
  "harbor.voting.rateAlso": "Rate also:",
  "harbor.voting.category.cleanliness": "Cleanliness",
  "harbor.voting.category.facilities": "Services",
  "harbor.voting.category.staff": "Staff",
  "harbor.voting.category.dock": "Mooring",
  "harbor.voting.category.waste": "Waste management",
  "harbor.voting.category.childrenAndYouth": "Children and youth",
  "harbor.voting.footerBlurb": "The Finnish Sailing and Boating Association has organized this vote since 1987. This year, favorites from both the coastal area and Lakeland will be recognized.",
  "harbor.voting.errorSave": "Could not save your rating. Please try again.",
  "harbor.voting.partnerLogos": "Partners",
  "vesselSettings.title": "Vessel settings",
  "vesselSettings.draft": "Draft",
  "vesselSettings.height": "Height",
  "vesselSettings.speed": "Average speed",
  "vesselSettings.draftHint": "Considered in fairway routing",
  "vesselSettings.heightHint": "Considered in fairway routing for bridges",
  "vesselSettings.speedHint": "Used in travel time calculation",
  "vesselSettings.presetSail": "Sailboat preset",
  "vesselSettings.presetMotor": "Motorboat preset",
  "weatherStation.defaultName": "Weather station",
  "weatherStation.updated": "Updated",
  "weatherStation.retry": "Retry",
  "weatherStation.error": "Failed to load weather station data.",
  "weatherStation.wind": "Wind",
  "weatherStation.gust": "Gust",
  "weatherStation.windDirection": "Wind direction",
  "weatherStation.temperature": "Temperature",
  "weatherStation.history": "History",
  "weatherStation.noHistory": "No history data available for this period.",
  "weatherStation.windAndGust": "Wind and gust",
  "weatherStation.dataAttribution": "Data: FMI (Finnish Meteorological Institute)",
  "weatherStation.last24h": "Last 24 h",
  "weatherStation.relativeTime.justNow": "just now",
  "weatherStation.relativeTime.minutesAgo": "{{count}} min ago",
  "weatherStation.relativeTime.hoursAgo": "{{count}} h ago",
  "weatherStation.relativeTime.daysAgo": "{{count}} days ago",
  "weatherStation.units.ms": "m/s",
  "weatherStation.units.celsius": "°C",
  "weatherStation.units.degrees": "°",

  "auth.login.title": "Log in",
  "auth.login.subtitle": "We’ll send a one-time code by email.",
  "auth.login.noAccount": "No account?",
  "auth.login.createAccount": "Create one",
  "auth.login.successTitle": "Signed in",

  "auth.register.title": "Create account",
  "auth.register.subtitle": "We’ll verify your email and set up your profile.",
  "auth.register.firstName": "First name",
  "auth.register.lastName": "Last name",
  "auth.register.haveAccount": "Already have an account?",
  "auth.register.goToLogin": "Log in",
  "auth.register.successTitle": "Account created",
  "auth.register.loginReady": "You can now log in with your new account.",
  "auth.register.privacyConsent": "I have read and understood the <0>privacy policy</0>.",
  "auth.register.privacyRequired": "Accepting the privacy policy is required for registration.",

  "auth.common.close": "Close",
  "auth.common.email": "Email address",
  "auth.common.emailHelper": "We’ll send a 6‑digit code to your email.",
  "auth.common.sendCode": "Send code",
  "auth.common.sending": "Sending…",
  "auth.common.successBody": "You can close this window.",

  "auth.otp.sentTitle": "Check your email",
  "auth.otp.sentBody": "We sent a 6‑digit verification code to {{email}}.",
  "auth.otp.codeLabel": "Verification code",
  "auth.otp.codeHelper": "Enter the 6-digit code.",
  "auth.otp.verify": "Verify",
  "auth.otp.verifying": "Verifying…",
  "auth.otp.changeEmail": "Change email",
  "auth.otp.noCode": "Didn’t get a code?",
  "auth.otp.resend": "Resend",
  "auth.otp.resendIn": "Resend in {{seconds}}s",

  "account.title": "Account",
  "account.subtitle": "Manage your profile and preferences.",
  "account.back": "Back to map",
  "account.loading": "Loading account…",
  "account.error": "Could not load account information.",
  "account.loginRequired": "Log in to view your account.",
  "account.profile.title": "Profile",
  "account.profile.name": "Name",
  "account.profile.email": "Email",
  "account.profile.membership": "Membership",
  "account.profile.merikarhutMember": "Merikarhut member",
  "account.subscription.title": "Subscriptions",
  "account.subscription.premium": "Sailmate Premium",
  "account.subscription.scout": "Partiolaisten reitit",
  "account.subscription.active": "Active",
  "account.subscription.expired": "Expired",
  "account.subscription.none": "Not subscribed",
  "account.subscription.activeUntil": "Active until {{date}}",
  "account.subscription.expiredOn": "Expired on {{date}}",
  "account.cookiePreferences": "Cookie preferences",
  "account.delete.title": "Delete account",
  "account.delete.description": "Permanently remove your account and data. This action cannot be undone.",
  "account.delete.button": "Delete account",
  "account.delete.confirmTitle": "Delete your account?",
  "account.delete.confirmBody": "This will permanently delete your account and all associated data. This action is irreversible.",
  "account.delete.confirmButton": "Delete permanently",
  "account.delete.inProgress": "Deleting…",
  "account.delete.errorMissingProfile": "We couldn't confirm your account details. Please refresh and try again.",
  "account.delete.errorMissingToken": "We couldn't verify your session. Please sign in again.",
  "account.delete.errorGeneric": "Something went wrong while deleting your account. Please try again.",

  "consent.title": "Analytics consent",
  "consent.message": "We use analytics to improve the app. You can accept or decline.",
  "consent.accept": "Accept",
  "consent.decline": "Decline",
  "consent.preferencesTitle": "Cookie preferences",
  "consent.currentlyAccepted": "Analytics are currently accepted.",
  "consent.currentlyDeclined": "Analytics are currently declined.",

  "menu.subscription": "Subscription",

  "subscription.title": "Sailmate subscriptions",
  "subscription.subtitle": "Choose the subscription that fits your needs. Premium brings powerful tools for navigation and route planning with clear charts, while Scout Routes offers proven shortcut routes plus additional information on harbors and destinations.",
  "subscription.planDetails": "Price includes VAT 25.5%. The subscription is valid for 12 months and renews automatically.",
  "subscription.scoutDescription": "Partiolaisten reitit -sisältöpaketti sisältää tarkat tiedot karttoineen yli 450:stä retki- ja luonnonsatamasta ja yli 2000 mpk merkitsemättömiä veneilyreittejä kartalle piirrettyinä. Satamia ja reittejä on Turunmaan saaristossa, Ahvenanmaalla, Suomenlahdella ja Pohjanlahdella. Sisältö on tehty yhteistyössä Turun Partio-Sissit Ry:n kanssa. Partiolaisten reitit -sisältöpaketin voi ostaa sekä Free- että Premium-tasoilla.",
  "subscription.benefits.title": "Why Sailmate Premium?",
  "subscription.benefits.subtitle": "Unlock the full Sailmate experience with powerful routing tools and curated scout routes.",
  "subscription.benefits.routes": "Advanced route planning with fairway-based routing",
  "subscription.benefits.places": "Save and manage your favourite places",
  "subscription.benefits.scoutRoutes": "Access to curated Scout routes (with Scout subscription)",
  "subscription.actions.manage": "Manage subscription",
  "subscription.actions.loading": "Loading…",
  "subscription.actions.open": "Open",
  "subscription.actions.buy": "Choose Premium",
  "subscription.actions.buyScout": "Choose Scout routes",
  "subscription.actions.changePlan": "Change or cancel in Stripe",
  "subscription.manageOnIos": "Manage on iPhone/iPad (App Store)",
  "subscription.manageOnAndroid": "Manage on Android (Google Play)",
  "subscription.manageOnMobileHint": "This subscription was purchased via a mobile store. Please manage it on your mobile device.",
  "subscription.promotionalTitle": "Promotional subscription",
  "subscription.promotionalBody": "This subscription was granted as a promotion and can’t be managed here.",
  "subscription.manageUnavailable": "Subscription management is not available for this purchase.",
  "subscription.management.title": "Manage your subscription",
  "subscription.management.subtitle": "Stripe securely handles your payments. You can update billing details or cancel at any time in the Stripe portal.",
  "subscription.disclaimer": "Prices, taxes and subscription terms are shown on the Stripe checkout page. By subscribing you accept the terms presented there.",
  "subscription.loginPrompt": "Log in to see your existing subscriptions or start a new one.",
  "subscription.header.routePlanning": "Route planning",
  "subscription.hero.kicker": "Boat more smoothly with Sailmate",
  "subscription.hero.title": "Choose the Sailmate subscription that suits how you move on the water and plan your routes.",
  "subscription.hero.pointPremium": "Powerful tools for navigation and planning",
  "subscription.hero.pointScout": "Harbor details and Scout shortcut routes",
  "subscription.hero.pointSync": "Clear raster and vector charts for navigation",
  "subscription.trust.secureTitle": "Secure and trusted payment",
  "subscription.trust.secureBody": "Your payment is processed securely by Stripe. Your card details are not stored in Sailmate.",
  "subscription.trust.secureProof": "Powered by Stripe",
  "subscription.trust.annualTitle": "Fast to start",
  "subscription.trust.annualBody": "Create your account in a minute and continue straight to checkout.",
  "subscription.trust.supportTitle": "Clear subscription terms",
  "subscription.trust.supportBody": "VAT, renewal details and billing terms are shown before you pay.",
  "subscription.actions.continuePremium": "Continue to Premium",
  "subscription.actions.continueScout": "Continue to Scout",
  "subscription.actions.choosePremium": "Choose Premium",
  "subscription.actions.chooseScout": "Choose Scout routes",
  "subscription.actions.chooseEstonianCharts": "Choose Estonian S57 vector charts",
  "subscription.restore.title": "Already purchased with this account?",
  "subscription.restore.body": "If you have subscribed earlier, log in with the same account to see your current subscriptions.",
  "subscription.restore.cta": "Log in and continue",
  "subscription.auth.kicker": "SMOOTH PURCHASE FLOW",
  "subscription.auth.title": "Create a Sailmate account or log in to continue your purchase.",
  "subscription.auth.subtitle": "If you've used Sailmate before, sign in with the same email address.",
  "subscription.auth.modeRegister": "Create account",
  "subscription.auth.modeLogin": "Log in",
  "subscription.auth.pendingTitle": "Continue to {{plan}}",
  "subscription.auth.pendingBody": "Verify your Sailmate account and we will continue you to {{plan}} checkout.",
  "subscription.auth.registerCta": "Create account and continue",
  "subscription.auth.loginCta": "Log in and continue",
  "subscription.auth.verifyCta": "Verify and continue",
  "subscription.auth.emailHelper": "We'll send a 6-digit code to your email.",
  "subscription.auth.otpSentBody": "We sent a 6-digit verification code to {{email}}.",
  "subscription.auth.successTitle": "Account ready. Continuing to checkout.",
  "subscription.auth.successBody": "You are signed in. Secure checkout will open automatically.",
  "subscription.auth.successSignedIn": "You are now signed in.",
  "subscription.signedIn.kicker": "Account ready",
  "subscription.signedIn.title": "You're signed in and ready to subscribe.",
  "subscription.signedIn.body": "Use your Sailmate account to start checkout, manage Stripe billing, or check your current subscription status.",
  "subscription.signedIn.readyChip": "Signed in",
  "subscription.signedIn.email": "Checkout and subscription management will use {{email}}.",
  "subscription.signedIn.switchEmail": "Log in with another email address",
  "subscription.redirecting.title": "Preparing checkout",
  "subscription.redirecting.body": "Your account is ready. We are continuing you to secure checkout.",
  "subscription.plan.featured": "Best for active navigation",
  "subscription.plan.addOn": "Great add-on for exploration",
  "subscription.plan.featuredShort": "Popular",
  "subscription.checkoutReady": "Checkout uses your Sailmate account email and opens in Stripe.",
  "subscription.errors.checkoutUnavailable": "We could not prepare checkout yet. Please confirm your account details and try again.",
  "subscription.premiumSubtitle": "For route planning and navigation",
  "subscription.premiumDescription": "Try Sailmate Premium free for 3 days. With Sailmate Premium, you can plan routes and access marine weather, harbor maps, additional chart layers, and AIS observations. It also includes navigation features such as position display, bearing line, speed display, distance ring, route track recording, and offline charts.\n\nBilling starts after the 3-day trial. You can cancel anytime during the trial period at no charge.",
  "subscription.premiumFeature1": "Clear S57 vector charts",
  "subscription.premiumFeature2": "Navigate with the mobile app",
  "subscription.premiumFeature3": "View harbor approach charts",
  "subscription.premiumFeature4": "Sync routes and favorites across all your devices",
  "subscription.scoutSubtitle": "Curated routes and harbor details for cruising",
  "subscription.estonianChartsTitle": "Estonian S57 vector charts",
  "subscription.estonianChartsSubtitle": "Add-on for Estonian waters",
  "subscription.estonianChartsDescription": "Adds Estonian S57 vector charts to your map.",
  "subscription.estonianChartsPremiumRequired": "Requires an active Sailmate Premium subscription.",
  "subscription.scoutDescriptionShort": "The Scouts' Routes content pack adds over 450 excursion and natural harbors and over 2,000 nautical miles of unmarked boating routes directly to the map. It covers the Archipelago Sea, Åland, the Gulf of Finland, and the Gulf of Bothnia, and has been created in collaboration with Turun Partio-Sissit ry.\n\nThe content pack is available for both Free and Premium plans.",
  "subscription.scoutFeature1": "More details on 450+ excursion and natural harbors",
  "subscription.scoutFeature2": "More than 2,000 nautical miles of routes",
  "subscription.scoutFeature3": "Curated Scout routes and harbor details for northern waters",
  "subscription.paymentReturn.successTitle": "Payment complete",
  "subscription.paymentReturn.successBody": "Your subscription is being activated. It may take a moment to appear.",
  "subscription.paymentReturn.cancelTitle": "Payment canceled",
  "subscription.paymentReturn.cancelBody": "No changes were made to your subscription. You can try again anytime.",
  "subscription.paymentReturn.unknownTitle": "Payment update",
  "subscription.paymentReturn.unknownBody": "We received a payment update. Please check your subscription status below.",
  "subscription.paymentReturn.errorTitle": "Payment failed",
  "subscription.paymentReturn.errorBody": "We couldn't complete your payment. Please try again or use a different card. If the problem persists, contact support.",
  "subscription.errors.misconfigured": "Stripe configuration is missing. Please contact support.",
  "subscription.errors.portalUnavailable": "Subscription management is not available at the moment.",

  "auth.errors.invalidForm": "Please check the fields and try again.",
  "auth.errors.invalidCode": "Enter a valid 6-digit code.",
  "auth.errors.emailInUse": "This email address is already in use. Try logging in instead.",
  "auth.errors.loginFailed": "Login failed. Check the address and try again. If you don't have an account, you can create one by selecting \"Create one\".",
  "auth.errors.otpFailed": "Code verification failed. Please try again.",
  "auth.errors.generic": "Something went wrong. Please try again.",
  "errorBoundary.title": "Something went wrong",
  "errorBoundary.subtitle": "Unexpected error",
  "errorBoundary.message": "An unexpected error occurred in the application. You can try again, reload the page, or return to the home page.",
  "errorBoundary.retry": "Try again",
  "errorBoundary.reload": "Reload page",
  "errorBoundary.goHome": "Go home",
  "errorBoundary.details": "Error details",
  "errorBoundary.copyError": "Copy error",
  "errorBoundary.errorMessage": "Error message",
  "errorBoundary.componentStack": "Component stack",
  "errorBoundary.helpText": "If the problem persists, please contact support.",
  "webglError.title": "WebGL Not Available",
  "webglError.subtitle": "Graphics acceleration required",
  "webglError.message": "This application requires WebGL to display maps and graphics. WebGL appears to be disabled or unavailable in your browser.",
  "webglError.howToEnable": "How to enable WebGL:",
  "webglError.step1": "Update your browser to the latest version",
  "webglError.step2": "Check your browser settings and enable hardware acceleration",
  "webglError.step3": "If using Chrome/Edge: Go to chrome://settings/system and enable 'Use hardware acceleration when available'",
  "webglError.reload": "Reload page",
  "webglError.helpText": "After enabling WebGL, reload the page to continue.",

  "onboarding.title": "Quick start",
  "onboarding.stepCount": "Step {{current}} of {{total}}",
  "onboarding.progressLabel": "Setup progress",
  "onboarding.selected": "Selected",
  "onboarding.dontShowAgain": "Do not show this again",
  "onboarding.back": "Back",
  "onboarding.finish": "Start sailing",
  "onboarding.next": "Next",
  "onboarding.step1.kicker": "Welcome",
  "onboarding.step1.title": "Welcome to the new Sailmate",
  "onboarding.step1.body": "Sailmate’s new web app offers even more comprehensive tools for planning successful boating trips. You may find missing features or errors in the new app — please tell us about them!",
  "onboarding.step1.pill1Title": "Easy route planning",
  "onboarding.step1.pill1Body": "Create route plans in the new easy-to-use web app and navigate with the Sailmate mobile app using a Premium subscription.",
  "onboarding.step1.pill2Title": "One view for boating",
  "onboarding.step1.pill2Body": "In Sailmate web, explore charts, harbors, weather, and AIS traffic in a single view.",
  "onboarding.step2.kicker": "Charts",
  "onboarding.step2.title": "Choose your chart style",
  "onboarding.step2.body": "Pick a starting chart layer. You can switch anytime from the Layers menu.",
  "onboarding.step2.rasterTitle": "Raster nautical chart",
  "onboarding.step2.rasterBody": "Official paper charts in digital form.",
  "onboarding.step2.rasterFeature1": "Official nautical chart",
  "onboarding.step2.rasterFeature2": "Familiar chart-series styling",
  "onboarding.step2.rasterFeature3": "Key information always visible",
  "onboarding.step2.vectorTitle": "Vector nautical chart",
  "onboarding.step2.vectorBody": "Clean vector styling that stays crisp as you zoom in and out.",
  "onboarding.step2.vectorFeature1": "Content adapts as you zoom in and out",
  "onboarding.step2.vectorFeature2": "Clearer presentation",
  "onboarding.step2.vectorFeature3": "Currently open-data based; official vector charts coming soon!",
  "onboarding.step2.footer": "Tip: Open Layers anytime to switch between raster and vector charts.",
  "onboarding.step3.kicker": "Subscriptions",
  "onboarding.step3.title": "Go further with Premium and Scout routes",
  "onboarding.step3.body": "Enhance your boating experience with a Premium subscription and the Scouts’ Routes content package.",
  "onboarding.step3.premiumTitle": "Premium",
  "onboarding.step3.premiumChip": "For navigation",
  "onboarding.step3.premiumBody": "With Premium, route plans become reality.",
  "onboarding.step3.premiumFeature1": "Navigate with the mobile app",
  "onboarding.step3.premiumFeature2": "Harbor approach charts",
  "onboarding.step3.premiumFeature3": "",
  "onboarding.step3.scoutTitle": "Scout routes",
  "onboarding.step3.scoutChip": "Local knowledge",
  "onboarding.step3.scoutBody": "Scout routes and harbor information.",
  "onboarding.step3.scoutFeature1": "Comprehensive details on 450+ trip and natural harbors",
  "onboarding.step3.scoutFeature2": "2,000 nautical miles of unmarked routes",
  "onboarding.step3.scoutFeature3": "",
  "onboarding.step3.viewPlans": "View plans",
  "onboarding.step3.login": "Log in",
  "onboarding.step3.loggedInHint": "You are signed in. Manage your subscription anytime from the account menu.",
  "onboarding.close": "Close",
  "onboarding.footerTour": "Explore the quick tour",
  "tour.stepCount": "Step {{current}} of {{total}}",
  "tour.back": "Back",
  "tour.next": "Next",
  "tour.done": "Finish",
  "tour.steps.menu.title": "Main menu",
  "tour.steps.menu.body": "Access account, routes, settings, and support in one place.",
  "tour.steps.routeDrawer.title": "Route plan drawer",
  "tour.steps.routeDrawer.body": "View the route plan waypoints and save the route to the cloud.",
  "tour.steps.routing.title": "Route planning mode",
  "tour.steps.routing.body": "Choose saved place add, automatic fairway routing, or manual routing. Add a place or waypoint by long-pressing the map.",
  "tour.steps.reach.title": "Reachable area",
  "tour.steps.reach.body": "See how far you can travel along fairways from the last waypoint, based on the distance you set.",
  "tour.steps.search.title": "Search",
  "tour.steps.search.body": "Jump to places and harbors instantly with smart search.",
  "tour.steps.savedPlace.title": "Add a saved place",
  "tour.steps.savedPlace.body": "When route editing is not active, you can add a saved place by long-pressing the map.",
  "tour.steps.editRoute.title": "Edit the route",
  "tour.steps.editRoute.body": "In route edit mode, add a waypoint by long-pressing the map. You can add a waypoint mid-leg by dragging the route to a new position. On touch screens, long-press the route line or a waypoint to start moving it.",
  "tour.steps.layers.title": "Layers",
  "tour.steps.layers.body": "Pick chart style and toggle weather, AIS, and overlays anytime.",
  "tour.steps.controls.title": "Map controls",
  "tour.steps.controls.body": "Zoom and reset north with one-hand controls.",
  "tour.steps.forecast.title": "Weather forecast",
  "tour.steps.forecast.body": "Toggle the forecast overlay to browse wind, gusts, temperature, and more over time. Tap the map for a point forecast."
}
